export default __webpack_public_path__ + "static/media/google-play-download.d1fc3d97.png";